<template>
  <h2>
    <GoBack class="mr-3"/>
    <template v-for="breadcrumb in breadcrumbs">
      <span v-if="breadcrumb.link" :key="nameBreadcrumb(breadcrumb)">
        <router-link :to="breadcrumb.link">{{ nameBreadcrumb(breadcrumb) }}</router-link>
        /
      </span>

      <strong v-else :key="nameBreadcrumb(breadcrumb)">{{ nameBreadcrumb(breadcrumb) }}</strong>
    </template>
  </h2>
</template>

<script>
  import GoBack from '@/components/shares/specialTag/GoBack'

  export default {
    components: { GoBack },
    methods: {
      nameBreadcrumb(breadcrumb) {
        if ('dynamicName' in breadcrumb)
          return breadcrumb.dynamicName()
        else
          return breadcrumb.name
      }
    },
    name: 'Breadcrumb',
    props: {
      breadcrumbs: { required: true, type: Array }
    }
  }
</script>

<style scoped>

</style>
